import {
  SYSTEM_OVERVIEW_SUCCESS,
  SYSTEM_OVERVIEW_START,
  SESSION_SUCCESS,
  SCHEDULE_SUCCESS,
  RX_SUCCESS,
  TX_SUCCESS,
  CONNECTION_SUCCESS,
  RXGROUP_SUCCESS,
  VW_SUCCESS,
} from "../types/index";

const dashboardInitialState = {
  connections: {
    total: 0,
    currentTime: 0,
  },
  logs: {
    info: 0,
    warn: 0,
    error: 0,
  },
  profiles: {
    total: 0,
    scheduleNum: 0,
    nextTriggerTime: 0,
    nextProfileName: null,
    nextProfileId: null,
  },
  rxs: {
    active: 0,
    standby: 0,
    offline: 0,
    unmanaged: 0,
  },
  servers: {
    total: 0,
    mode: 0,
    state: 0,
    status: 0,
    peerAddr: "",
  },
  sessions: {
    web: 0,
    osd: 0,
    cli: 0,
    txi: 0,
  },
  txs: {
    active: 0,
    standby: 0,
    offline: 0,
    unmanaged: 0,
  },
  users: {
    online: 0,
    idle: 0,
  },
  switch: {
    startup: 0,
    offline: 0,
    statistics: 0,
  },
};

const dashboardReducer = (state = dashboardInitialState, action) => {
  switch (action.type) {
    case SYSTEM_OVERVIEW_SUCCESS:
      return {
        connections: action.systemOverview.connections,
        logs: action.systemOverview.logs,
        profiles: action.systemOverview.profiles,
        rxs: action.systemOverview.rxs,
        servers: action.systemOverview.servers,
        sessions: action.systemOverview.sessions,
        txs: action.systemOverview.txs,
        users: action.systemOverview.users,
        switch: action.systemOverview.switch,
      };
      break;
    default:
      return state;
      break;
  }
};

const sessionInitialState = [];

const sessionReducer = (state = sessionInitialState, action) => {
  switch (action.type) {
    case SESSION_SUCCESS:
      return action.session;
      break;
    default:
      return state;
      break;
  }
};

const scheduleInitialState = [];

const scheduleReducer = (state = scheduleInitialState, action) => {
  switch (action.type) {
    case SCHEDULE_SUCCESS:
      return action.schedule;
      break;
    default:
      return state;
      break;
  }
};

const RXInitialState = [];

const RXReducer = (state = RXInitialState, action) => {
  switch (action.type) {
    case RX_SUCCESS:
      return action.rx;
      break;
    default:
      return state;
      break;
  }
};
const TXInitialState = [];

const TXReducer = (state = TXInitialState, action) => {
  switch (action.type) {
    case TX_SUCCESS:
      return action.tx;
      break;
    default:
      return state;
      break;
  }
};

const connectionInitialState = [];

const connectionReducer = (state = connectionInitialState, action) => {
  switch (action.type) {
    case CONNECTION_SUCCESS:
      return action.connection;
      break;
    default:
      return state;
      break;
  }
};

const RXGroupInitialState = [];

const RXGroupReducer = (state = RXGroupInitialState, action) => {
  switch (action.type) {
    case RXGROUP_SUCCESS:
      return action.rgroups;
      break;
    default:
      return state;
      break;
  }
};

const VWInitialState = [];

const VWReducer = (state = VWInitialState, action) => {
  switch (action.type) {
    case VW_SUCCESS:
      return action.vws;
      break;
    default:
      return state;
      break;
  }
};

export {
  dashboardReducer,
  sessionReducer,
  scheduleReducer,
  RXReducer,
  TXReducer,
  connectionReducer,
  RXGroupReducer,
  VWReducer,
};
